import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyChatbot = lazyWithRetry(() => import("./Chatbot"));

const Chatbot = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyChatbot {...props} />;

export default Chatbot;
